import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 
import Login from './components/login'
import Navbar from './components/dashboard';
import SetPasswordFirstTime from './components/setPasswordFirstTime';
import PreviewPage from './components/previewInventory';
import PreviewDeliveryChallan from './components/previewDeliveryChallan';
import PreviewGatePass from './components/gatePassPreview';
import IssueRequestPreview from './components/issueRequestPreview';
import IssueSlipPreview from './components/issueSlipPreview';
import ReturnSlipPreview from './components/returnSlipPreview';
import ReturnAcceptancePreview from './components/returnAcceptancePreview';
import PreviewOpeningStock from './components/previewOpeningStock';
import ForgotPassword from './components/forgotPassword';
import PreviewLocationTransfer from './components/previewTransferLocation';
import PreviewStatusTransfer from './components/previewTransferStatus';
import PreviewReceiptVoucher from './components/PreviewReceiptVoucher';
import PreviewExternalReceiptVoucher from './components/PreviewExternalReceiptPreview';
import ApproveReceiptVoucher from './components/ApproveReceiptVoucher';
import PreviewOpeningStockLedger from './components/previewOpeningStockLedger';
import PreviewInventoryLedger from './components/previewInventoryLedger';
import ItemConversionPreview from './components/ItemConversionPreview';
import UnusableProductionPreview from './components/previewUnusableProduction';
import TransactionEntryPreview from './components/previewTransactionEntry';
import ProjectRequirementPreview from './components/previewProjectRequirement';
import ConsolidatedReport from './components/consolidatedRequirementPreview';
import RequirementAssessment from './components/requirementAssessment';
import RequirementReport from './components/requirementReport';
import MRPreview from './components/previewMR';
import DepartmentIssueRequestReport from './components/DepartmentIssueReport';
import ConfirmationLetter from './components/confirmationLetter';
import ConfirmationLetterPreview from './components/confirmationLetterPreview';
import DonationForm from './components/donationForm';
import IssueSlip from './components/issueSlip';
import ReturnSlip from './components/returnSlip';
import ReturnAcceptance from './components/returnAcceptance';
import DonationPreview from './components/donationPreview';
import ProjectRequirementReport from './components/projectReport';
const App = () => {
  // let token=localStorage.getItem('token')
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />:
        <Route path="/dashboard/*" element={<Navbar />} />
        <Route path='/setPassword' element={<SetPasswordFirstTime/>}/>
        <Route path='/previewInventory/' element={<PreviewPage/>}/>
        <Route path='/previewTransferLocation/' element={<PreviewLocationTransfer/>}/>
        <Route path='/previewTransferStatus/' element={<PreviewStatusTransfer/>}/>
        <Route path='/PreviewOpeningStock/' element={<PreviewOpeningStock/>}/>
        <Route path='/PreviewDeliveryChallan/' element={<PreviewDeliveryChallan/>}/>
        <Route path='/PreviewGatePass/' element={<PreviewGatePass/>}/>
        <Route path='/IssueRequestPreview/' element={<IssueRequestPreview/>}/>
        <Route path='/IssueSlipPreview/' element={<IssueSlipPreview/>}/>
        <Route path='/ReturnSlipPreview/' element={<ReturnSlipPreview/>}/>
        <Route path='/ReturnAcceptancePreview/' element={<ReturnAcceptancePreview/>}/>
        <Route path='/forgotPassword' element={<ForgotPassword/>}/>
        <Route path='/previewReceiptVoucher' element={<PreviewReceiptVoucher/>} />
        <Route path='/ApproveReceiptVoucher' element={<ApproveReceiptVoucher/>} />
        <Route path='/PreviewExternalReceiptVoucher' element={<PreviewExternalReceiptVoucher/>} />
        <Route path='/PreviewOpeningStockLedger' element={<PreviewOpeningStockLedger/>}/>
        <Route path='/PreviewInventoryLedger' element={<PreviewInventoryLedger/>}/>
        <Route path='/ItemConversionPreview' element={<ItemConversionPreview />} />
        <Route path='/UnusableProductionPreview' element={<UnusableProductionPreview />} />
        <Route path='/TransactionEntryPreview' element={<TransactionEntryPreview />} />
        <Route path='/ProjectRequirementPreview' element={<ProjectRequirementPreview />} />
        <Route path='/ConsolidatedReport' element={<ConsolidatedReport />} />
        <Route path='/RequirementAssessment' element={<RequirementAssessment />} />
        <Route path='/RequirementReport' element={<RequirementReport />} />
        <Route path='/MRPreview' element={<MRPreview />} />
        <Route path='/DepartmentIssueRequestReport' element={<DepartmentIssueRequestReport />} />
        <Route path='/ConfirmationLetter' element={<ConfirmationLetter />} />
        <Route path='/ConfirmationLetterPreview' element={<ConfirmationLetterPreview />} />
        <Route path='/DonationForm' element={<DonationForm />} />
        <Route path='/IssueSlip' element={<IssueSlip />} />
        <Route path='/ReturnSlip' element={<ReturnSlip />} />
        <Route path='/ReturnAcceptance' element={<ReturnAcceptance />} />
        <Route path='/DonationPreview' element={<DonationPreview />} />
        <Route path='/ProjectReport' element={<ProjectRequirementReport />} />
      </Routes>
    </Router>
  );
};

export default App;